<template>
  <v-container class="pa-3" fluid>
    <v-card class="pa-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Login Logs</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6">
          <!-- <v-btn outlined rounded class="btnexport">
              <span>Export PDF</span>
              <v-icon small center>mdi-download</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.user_id = 0;
            })
            " v-model="datasearch.user_id" :items="emp_list" item-text="name" item-value="id" label="Employee Name"
            outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="menudatefrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateFromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                dense outlined v-bind="attrs" v-on="on" clearable @click:clear="
                  $nextTick(() => {
                    datasearch.datefrom = null;
                    datasearch.dateto = null;
                  })
                  "></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.datefrom" @input="menudatefrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="menudateto" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly dense
                outlined v-bind="attrs" v-on="on" clearable @click:clear="
                  $nextTick(() => {
                    datasearch.datefrom = null;
                    datasearch.dateto = null;
                  })
                  "></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.dateto" @input="menudateto = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.status = '';
            })
            " v-model="datasearch.status" :items="status_list" item-text="name" item-value="status_id" label="Status"
            outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn @click="onSearchPagination">
            <v-icon left>mdi-magnify</v-icon> Search</v-btn>
        </v-col>
      </v-row>

      <v-card outlined tile>
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
        >
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onSearchPagination" style="width: 150px" :items="item_per_page_list"
            label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="Number(totalItems)"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="pb-4"></div>

      <template>
        <div id="mydivhtmltobase">
          <div v-for="index in datashowAll.length" v-if="datashowAll.length >= 0 || pageAll >= 0">
            <div class="aligncenter" id="foo">
              <v-pagination size="A4" class="aligncenter">
                <br />
                <div class="aligncenter">
                  <div class="rowprpo ">
                    <div class="col-md-6report"></div>
                    <div class="col-md-6report">
                      <p class="alignright  colprpo mr30prpo mt10 mb-5">
                        Page : {{ index }}
                      </p>
                    </div>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div class="rowprpo aligncenter mb-5">
                    <div class="col-md-12report mt-30prpo">
                      <h2>
                        {{ dataformatpr.title }}
                      </h2>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h3>
                        {{ dataformatpr.subtitle }}
                      </h3>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h5 v-if="dataformatpr.datefrom && dataformatpr.dateto">
                        Date From {{ dataformatpr.datefrom }} T0
                        {{ dataformatpr.dateto }}
                      </h5>
                    </div>
                  </div>
                </div>
                <br />
                <div class="rowprpo caption  ml30prpo mr30prpo mb-2" style="
                          margin-top:10px
                        ">
                  <table class="captionhtable ">
                    <tr>
                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width10 ">
                        <span>ID</span>
                      </th>

                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width25">
                        <span class="alignleft">Username </span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width45">
                        <span class="alignleft">Name </span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width30">
                        <span class="aligncenter">Log in Date</span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width30">
                        <span class="aligncenter">Log out Date</span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width30">
                        <span class="aligncenter">Last Update</span>
                      </th>
                      <th scope="colgroup" class=" prborderbottom2pxhtable prbordertop2pxhtable width18">
                        <span class="aligncenter">Status</span>
                      </th>
                    </tr>
                  </table>
                </div>
                <div v-for="(data, i) in datashowAll[index - 1]" id="content"
                  class="rowprpo caption  ml30prpo mr30prpo">
                  <table class="">
                    <tr valign="top">
                      <th class="width10">
                        <span v-if="data.id">{{ data.id }}</span>
                        <span v-else>-</span>
                      </th>

                      <th class="width25">
                        <span class="alignleft" v-if="data.username">{{
                          data.username
                        }}</span>
                        <span class="alignleft" v-else>-</span>
                      </th>
                      <th class="width45">
                        <span class="alignleft" v-if="data.name">{{
                          data.name
                        }}</span>
                        <span class="alignleft" v-else>-</span>
                      </th>
                      <th class="width30">
                        <span class="aligncenter" v-if="data.date_in">{{ data.date_in_print }}<br />{{
                          data.time_in_print
                        }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                      <th class="width30">
                        <span class="aligncenter" v-if="data.date_out">{{ data.date_out_print }}<br />{{
                          data.time_out_print
                        }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                      <th class="width30">
                        <span class="aligncenter" v-if="data.last_update">{{ data.date_last_update_print }}<br />
                          {{ data.time_last_update_print }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                      <th class="width18">
                        <span class="aligncenter" v-if="data.status">{{
                          data.status
                        }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                    </tr>
                  </table>
                </div>
              </v-pagination>
            </div>
          </div>
        </div>
      </template>

      <v-card-actions class="mt-5">
        <v-spacer></v-spacer>

        <v-btn v-if="this.datashowAll.length > 0" depressed outlined buttonred width="100" @click="exportToPDF">
          print
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
export default {
  async mounted() {
    this.$showLoader();   // แสดง loader ตั้งแต่ต้น
    try {
      await api.checkVersion();
      this.mycompany_id = localStorage.getItem(server.COMPANYID);

      // รอทั้งหมดให้เสร็จจริงก่อน
      await this.loadDepartmentByCompanyId();
      await this.loadCustomer();
      await this.loadEmp();

    } catch (e) {
      console.error("โหลดข้อมูลล้มเหลว:", e);
    } finally {
      this.$hideLoader();
    }
  },
  components: {
    SuccessDialog,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      showsearchsum: false,
      employeeisdisable: false,
      exportleavereport: "leave_report.xlsx",
      sheets: [
        {
          name: "InvioceReport",
          data: [],
        },
      ],
      search: "",
      headers: [
        {
          text: "Login ID",
          value: "id",
          class: "bg-colorth tabletextwhite",
          align: "end",
          width: "100px",
        },
        {
          text: "User Name",
          value: "username",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Name",
          value: "name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Log in Date",
          value: "date_in",
          class: "bg-colorth tabletextwhite",
          align: "center",
        },
        {
          text: "Log out Date",
          value: "date_out",
          class: "bg-colorth tabletextwhite",
          align: "center",
        },
        {
          text: "Last Update",
          value: "last_update",
          class: "bg-colorth tabletextwhite",
          align: "center",
        },
        {
          text: "Status",
          value: "status",
          class: "bg-colorth tabletextwhite",
        },
      ],
      mDataArray: [],
      dataAll: [],
      sum_show_table: [],
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        user_id: 0,
        datefrom: null,
        dateto: null,
        status: "",
      },
      dateCurrent: this.formatDateday(new Date().toISOString().substr(0, 10)),
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",

      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
      status_list: [
        {
          name: "Close",
          status_id: "Close",
        },
        {
          name: "IN SYSTEM",
          status_id: "IN SYSTEM",
        },
      ],
      dataformatpr: {
        title: "",
        subtitle: "Login Log Report",
        dateto: "",
        datefrom: "",
      },
      dataforshowprpo: {},
    };
  },
  methods: {
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;

      if (
        !this.datasearch.datefrom &&
        !this.datasearch.dateto &&
        this.datasearch.user_id == 0 &&
        !this.datasearch.status
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือกข้อมูล เงือนไขการค้นหา",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.datefrom && !this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && !this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && this.datasearch.datefrom) {
        if (this.datasearch.dateto < this.datasearch.datefrom) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "กรุณาเลือก DateTo >= DateFrom ",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      this.$showLoader();

      try {
        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          department,
          status
     */

        this.$showLoader();
        let resultsearch = await api.getLogInOutLogBySearchPagination(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          this.datasearch.user_id,
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.status
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID)
        );

        if (resultsearch.data.data.length > 0) {
          this.dataAll2 = resultsearch.data.data[0];
          this.mDataArray2 = this.dataAll2;

          // show pdf

          await this.setexporttoxlsx();

          this.dataformatpr.title = copany_datat.data[0].name;
          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data.data[0];
          await this.checkcontent();

          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center"
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    formatDate(date) {
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;

      if (this.datasearch.user_id == 0) {
        this.datasearch.user_id = localStorage.getItem(server.USER_ID);

        let currentDate = new Date();

        // วันแรกของเดือน
        let firstDay = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );

        // วันสุดท้ายของเดือน
        let lastDay = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        );

        // แปลงเป็น string format YYYY-MM-DD โดยไม่ใช้ toISOString()
        this.datasearch.datefrom = this.formatDate(firstDay);
        this.datasearch.dateto = this.formatDate(lastDay);

      }

      if (
        !this.datasearch.datefrom &&
        !this.datasearch.dateto &&
        this.datasearch.user_id == 0 &&
        !this.datasearch.status
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือกข้อมูล เงือนไขการค้นหา",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.datefrom && !this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && !this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && this.datasearch.datefrom) {
        if (this.datasearch.dateto < this.datasearch.datefrom) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "กรุณาเลือก DateTo >= DateFrom ",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      try {
        /*
          page,
          limit,
          sortBy,
          sortOrder,
          user_id,
          com_id,
          datefrom,
          dateto,
          status
     */

        //log param

        let resultsearch = await api.getLogInOutLogBySearchPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.datasearch.user_id,
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.status
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID)
        );

        if (resultsearch.data.data.length > 0) {
          this.dataAll2 = resultsearch.data.data[0];
          this.mDataArray2 = this.dataAll2;

          // show pdf

          await this.setexporttoxlsx();

          this.dataformatpr.title = copany_datat.data[0].name;
          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data.data[0];
          await this.checkcontent();


        } else {
          this.$hideLoader();
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      if (
        !this.datasearch.datefrom &&
        !this.datasearch.dateto &&
        this.datasearch.user_id == 0 &&
        !this.datasearch.status
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือกข้อมูล เงือนไขการค้นหา",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.datefrom && !this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && !this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && this.datasearch.datefrom) {
        if (this.datasearch.dateto < this.datasearch.datefrom) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "กรุณาเลือก DateTo >= DateFrom ",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      this.$showLoader();

      try {
        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          department,
          status
     */

        this.$showLoader();
        let resultsearch = await api.getLogInOutLogBySearchPagination(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          this.datasearch.user_id,
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.status
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID)
        );

        if (resultsearch.data.data.length > 0) {
          this.dataAll2 = resultsearch.data.data[0];
          this.mDataArray2 = this.dataAll2;

          // show pdf

          await this.setexporttoxlsx();

          this.dataformatpr.title = copany_datat.data[0].name;
          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data.data[0];
          await this.checkcontent();

          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center"
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;

      if (
        !this.datasearch.datefrom &&
        !this.datasearch.dateto &&
        this.datasearch.user_id == 0 &&
        !this.datasearch.status
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือกข้อมูล เงือนไขการค้นหา",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.datefrom && !this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && !this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && this.datasearch.datefrom) {
        if (this.datasearch.dateto < this.datasearch.datefrom) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "กรุณาเลือก DateTo >= DateFrom ",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      this.$showLoader();

      try {
        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          department,
          status
     */

        this.$showLoader();
        let resultsearch = await api.getLogInOutLogBySearchPagination(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          this.datasearch.user_id,
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.status
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID)
        );

        if (resultsearch.data.data.length > 0) {
          this.dataAll2 = resultsearch.data.data[0];
          this.mDataArray2 = this.dataAll2;

          // show pdf

          await this.setexporttoxlsx();

          this.dataformatpr.title = copany_datat.data[0].name;
          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data.data[0];
          await this.checkcontent();

          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center"
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async loadEmp() {

      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );
      if (result.data && result.data.length > 0) {
        this.emp_list = result.data;
      }

    },
    onCreated(wb) {

    },
    onChange(wb) {

      const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];
      wb.Sheets.leavereport.A1 = {
        t: "s",
        v: `Export Login-out Report as of   ${this.dateCurrent}`,
      };
      wb.Sheets.leavereport.B1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.C1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.D1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.E1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.F1 = { t: "s", v: "" };
      wb.Sheets.leavereport.G1 = { t: "s", v: "" };
      wb.Sheets.leavereport.H1 = { t: "s", v: "" };
      wb.Sheets.leavereport.I1 = { t: "s", v: "" };
      wb.Sheets.leavereport.J1 = { t: "s", v: "" };
      wb.Sheets.leavereport.K1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.L1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.M1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.N1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.O1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.P1 = { t: "s", v: "" };

      wb.Sheets.leavereport.A3 = { t: "s", v: "Employee" };
      wb.Sheets.leavereport.B3 = { t: "s", v: "Leave Type" };
      wb.Sheets.leavereport.C3 = { t: "s", v: "date time from" };
      wb.Sheets.leavereport.D3 = { t: "s", v: "date time to" };
      wb.Sheets.leavereport.E3 = { t: "s", v: "" };
      wb.Sheets.leavereport.F3 = { t: "s", v: "Description" };
      // wb.Sheets.leavereport.I3 = { t: "s", v: "report" };
      // wb.Sheets.leavereport.J3 = { t: "s", v: "payment Request" };
      // wb.Sheets.leavereport.K3 = { t: "s", v: "Cert" };
      // wb.Sheets.leavereport.L3 = { t: "s", v: "Done" };
      // wb.Sheets.leavereport.M3 = { t: "s", v: "Next90" };
      // wb.Sheets.leavereport.N3 = { t: "s", v: "Next60" };

      wb.Sheets.leavereport["!merges"] = merge;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.getNewAllDepartment_By_CompanyID(this.mycompany_id);
      this.department_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_list = result.data;

    },

    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {
        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },

    async SearchAlldata() {
      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.dataAll = [];
      this.mDataArray = [];

      if (this.datasearch.user_id == 0) {
        this.datasearch.user_id = localStorage.getItem(server.USER_ID);
        // this.datasearch.datefrom และ this.datasearch.dateto ขอเป็นวันแรกของเดือนและวันสุดท้ายของเดือน
        let currentDate = new Date();
        let firstDay = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        let lastDay = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        );
        this.datasearch.datefrom = firstDay.toISOString().substr(0, 10);
        this.datasearch.dateto = lastDay.toISOString().substr(0, 10);

      }

      if (
        !this.datasearch.datefrom &&
        !this.datasearch.dateto &&
        this.datasearch.user_id == 0 &&
        !this.datasearch.status
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือกข้อมูล เงือนไขการค้นหา",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.datefrom && !this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && !this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.datasearch.dateto && this.datasearch.datefrom) {
        if (this.datasearch.dateto < this.datasearch.datefrom) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "กรุณาเลือก DateTo >= DateFrom ",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      this.$showLoader();
      var res_search = await api.getLogInOutLogBySearch(
        localStorage.getItem(server.COMPANYID),
        { params: this.datasearch }
      );
      let copany_datat = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );


      if (res_search.data.length > 0) {
        this.dataAll = res_search.data;
        this.mDataArray = this.dataAll;

        // show pdf

        await this.setexporttoxlsx();

        this.dataformatpr.title = copany_datat.data[0].name;
        this.dataformatpr.datefrom = unity.formatDate(this.datasearch.datefrom);
        this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

        this.dataforshowprpo = res_search.data;
        await this.checkcontent();

        this.$hideLoader();
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "ไม่มีข้อมูล",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async setexporttoxlsx() {
      let setexportxlsx = [{}, {}];
      this.mDataArray2.forEach((x, index) => {
        setexportxlsx.splice(index + 2, 0, {
          id: x.id,
          username: x.username,
          name: x.name,
          date_in: x.date_in,
          date_out: x.date_out,
          last_update: x.last_update,
          status: x.status,
        });
      });
      this.sheets[0].data = setexportxlsx;
    },

    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    async checkcontent() {
      let totalclient = 0;
      this.setdatatoshow = [];
      let linedetailprpo = 40;
      let datainlineprpo = 14;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;


      for (let i = 0; i < this.dataforshowprpo.length; i++) {
        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก

        newhllinedetails = 0;
        getnewdata = [];

        this.dataforshowprpo[i].no = i + 1;

        let stringchecklength = "";

        if (this.dataforshowprpo[i].name != null) {
          let lengthofdataforshowprpo = this.dataforshowprpo[i].name.length;
          stringchecklength = this.dataforshowprpo[i].name;

          for (let j = 0; j < this.dataforshowprpo[i].name.length; j++) {
            if (
              stringchecklength[j] == maiek ||
              stringchecklength[j] == maito ||
              stringchecklength[j] == maitree ||
              stringchecklength[j] == maijattawa ||
              stringchecklength[j] == vowelei ||
              stringchecklength[j] == vowelee ||
              stringchecklength[j] == voweleue ||
              stringchecklength[j] == voweleu ||
              stringchecklength[j] == vowelu ||
              stringchecklength[j] == voweluu ||
              stringchecklength[j] == maihun ||
              stringchecklength[j] == maiyamok
            ) {
              lengthofdataforshowprpo--;
            }
          }

          newhllinedetails = Math.ceil(
            lengthofdataforshowprpo / datainlineprpo
          );

          getnewdata.push(this.dataforshowprpo[i]);

          if (
            hllinedetails + newhllinedetails > linedetailprpo ||
            this.dataforshowprpo[i].changedepartment == true
          ) {

            this.setdatatoshow[this.pageAll - 1] = getdata;
            this.pageAll++;

            hllinedetails = 0;
            getdata = [];
            getdata.push(this.dataforshowprpo[i]);
            hllinedetails += newhllinedetails;
            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          } else {
            hllinedetails += newhllinedetails;

            getdata.push(this.dataforshowprpo[i]);

            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          }
        } else {
          if (this.dataforshowprpo[i].date_in == null) {
            this.dataforshowprpo[i].date_in = "-";
          }
          let lengthofdataforshowprpo = this.dataforshowprpo[i].date_in.length;
          stringchecklength = this.dataforshowprpo[i].date_in;

          for (let j = 0; j < this.dataforshowprpo[i].date_in.length; j++) {
            if (
              stringchecklength[j] == maiek ||
              stringchecklength[j] == maito ||
              stringchecklength[j] == maitree ||
              stringchecklength[j] == maijattawa ||
              stringchecklength[j] == vowelei ||
              stringchecklength[j] == vowelee ||
              stringchecklength[j] == voweleue ||
              stringchecklength[j] == voweleu ||
              stringchecklength[j] == vowelu ||
              stringchecklength[j] == voweluu ||
              stringchecklength[j] == maihun ||
              stringchecklength[j] == maiyamok
            ) {
              lengthofdataforshowprpo--;
            }
          }

          newhllinedetails = Math.ceil(
            lengthofdataforshowprpo / datainlineprpo
          );

          getnewdata.push(this.dataforshowprpo[i]);

          if (
            hllinedetails + newhllinedetails > linedetailprpo ||
            this.dataforshowprpo[i].changedepartment == true
          ) {

            this.setdatatoshow[this.pageAll - 1] = getdata;
            this.pageAll++;

            hllinedetails = 0;
            getdata = [];
            getdata.push(this.dataforshowprpo[i]);
            hllinedetails += newhllinedetails;
            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          } else {
            hllinedetails += newhllinedetails;

            getdata.push(this.dataforshowprpo[i]);

            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          }
        }
      }

      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;

      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });

    },

    async exportToPDF(advance_id) {
      this.$showLoader();
      // this.$refs.html2Pdf.generatePdf();
      let element = document.getElementById("mydivhtmltobase");

      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {

          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          // var filtered = pdf.internal.pages.filter(function(el) {
          //   return el != null;
          // });

          // pdf.internal.pages = filtered;
          // for (let i = 0; i < totalPages; i++) {
          //   if (i == totalPages - 1) {
          //     pdf.internal.pages.splice(i, 1);
          //   }
          // }
          // pdf.addPage();


          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());

      // let formData = new FormData();
      // formData.append(`file`, blob, "test.pdf");
      // const resultadd = api.creatememoMaster(formData);


      // };
      this.$hideLoader();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.borderblockpr {
  border: 2px solid black;
  width: 100px;
  height: 150px;
  background: white;
  box-sizing: border-box;
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignleftcus {
  text-align: left;
}

.textalignright {
  text-align: right;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  border-top: 2px solid black;
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 2px solid black;
}

td {
  /* border: 1px solid black; */
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width18 {
  word-wrap: break-word;
  width: 18%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width25 {
  word-wrap: break-word;
  width: 22%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width35 {
  word-wrap: break-word;
  width: 35%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width45 {
  word-wrap: break-word;
  width: 45%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
                body.A3.landscape { width: 420mm }
                body.A3, body.A4.landscape { width: 297mm }
                body.A4, body.A5.landscape { width: 210mm }
                body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 90%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fontsize10 {
  font-size: 10px;
}

.v-btn:not(.v-btn--round).v-size--default.btnimport {
  background-color: #ffffff;
  color: #25b360;
}

.v-btn:not(.v-btn--round).v-size--default.btnexport {
  background-color: #ffffff;
  color: #33a4c0;
}
</style>
